import { render, staticRenderFns } from "./Research.vue?vue&type=template&id=607873f0&scoped=true"
import script from "./Research.vue?vue&type=script&lang=ts"
export * from "./Research.vue?vue&type=script&lang=ts"
import style0 from "./Research.vue?vue&type=style&index=0&id=607873f0&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "607873f0",
  null
  
)

export default component.exports